<template>
    <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12" md="6">
        <v-container class="fare">
            <div class="fare-title-container">
                <span class="fare-title">Tarifa {{ fareIndex }}</span>
                <div class="pb-0">
                    <v-btn
                        class="remove-fare-button"
                        outlined
                        x-small
                        fab
                        color="error"
                        @click="removeFare()"
                        :disabled="fareIndex === 1"
                    >
                        <span class="font-weight-bold">X</span>
                    </v-btn>
                </div>
            </div>
            <v-container v-if="active === 0" class="ma-0 px-2 py-1 inactive" >
                <v-icon color="#FFF">mdi-alert</v-icon><span>Tarifa inativa!</span>
            </v-container>
            <v-row class="mt-0">
                <v-col cols="12">
                    <v-checkbox
                        v-model="breakfast"
                        label="Café da Manhã"
                        hide-details="auto"
                    ></v-checkbox>
                </v-col>
                <v-col class="mt-2" cols="12">
                    <v-text-field
                        dense
                        outlined
                        v-model.lazy="value"
                        :rules="valueRules"
                        label="Valor da Diária"
                        v-money="money"
                        required
                        hide-details="auto"
                        class="rounded-lg"
                    ></v-text-field>
                </v-col>
                <v-col class="mt-2" cols="12">
                    <v-menu
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                dense
                                v-model="visibleExpirationDate"
                                label="Tarifa válida até"
                                outlined
                                readonly
                                hide-details="auto"
                                class="rounded-lg"
                                :rules="visibleExpirationDateRules"
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="expirationDate"
                            locale="pt-BR"
                            :first-day-of-week="1"
                            no-title
                            :allowed-dates="(date) => date >= today"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col class="mt-2" cols="12">
                    <div class="fare-section-label">Tarifa disponível em: </div>
                    <div class="week-days-selector">
                        <v-chip
                            v-for="day in daysOfWeek"
                            :key="day.value"
                            small
                            :color="getWeekDaysChipColor(day)"
                            :outlined="weekDays.indexOf(day.value) === -1 && !isDayDisabled(day.value)"
                            class="ma-1"
                            :class="{ 'disabled-day-chip': isDayDisabled(day.value) }"
                            :error="!hasSelectedAtLeastOneWeekDay"
                            @click="toggleDay(day.value)"
                        >{{ day.label }}</v-chip>
                    </div>
                    <div v-if="!hasSelectedAtLeastOneWeekDay" class="py-0 text-center">
                        <span class="week-days-error-message red--text">
                            <template v-if="allDaysBlocked">Somente uma tarifa {{ breakfast ? 'com' : 'sem' }} café da manhã pode estar disponível por dia no mesmo quarto.</template>
                            <template v-else>Selecione pelo menos um dia da semana</template>
                        </span>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-col>
    <tbody v-else>
        <tr class="fare-row">
            <td>
                <span class="fare-title">Tarifa {{ fareIndex }}</span>
            </td>
            <td>
                <span class="content-center">
                    <v-checkbox
                        v-model="breakfast"
                        hide-details="auto"
                        style="margin-bottom: 0.75rem;"
                    />
                </span>
            </td>
            <td style="min-width: 130px;">
                <span class="content-center daily-value">
                    <v-text-field
                        outlined
                        dense
                        class="rounded-lg"
                        light
                        v-model.lazy="value"
                        :rules="valueRules"
                        v-money="money"
                        required
                        hide-details="auto"
                    />
                </span>
            </td>
            <td style="min-width: 150px;">
                <span class="content-center expiration-date">
                    <v-menu
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                dense
                                class="rounded-lg"
                                v-model="visibleExpirationDate"
                                readonly
                                outlined
                                light
                                hide-details="auto"
                                :rules="visibleExpirationDateRules"
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                style="text-align: center"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="expirationDate"
                            locale="pt-BR"
                            :first-day-of-week="1"
                            no-title
                            :allowed-dates="(date) => date >= today"
                        ></v-date-picker>
                    </v-menu>
                </span>
            </td>
            <td>
                <span class="content-center">
                    <v-btn
                        icon
                        color="error"
                        @click="removeFare()"
                        :disabled="fareIndex === 1"
                    >
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </span>
            </td>
        </tr>
        <tr class="fare-week-days-row">
            <td colspan="7">
                <div class="d-flex justify-center align-center flex-wrap px-2 py-1">
                    <span class="week-days-label mr-2">Tarifa disponível em:</span>
                    <v-chip
                        v-for="day in daysOfWeek"
                        :key="day.value"
                        small
                        :color="getWeekDaysChipColor(day)"
                        :outlined="weekDays.indexOf(day.value) === -1 && !isDayDisabled(day.value)"
                        class="ma-1"
                        :class="{ 'disabled-day-chip': isDayDisabled(day.value) }"
                        :error="!hasSelectedAtLeastOneWeekDay"
                        @click="toggleDay(day.value)"
                    >{{ day.label }}</v-chip>
                </div>
                <div v-if="!hasSelectedAtLeastOneWeekDay" class="px-2 py-0 text-center">
                    <span class="week-days-error-message red--text">
                        <template v-if="allDaysBlocked">Somente uma tarifa {{ breakfast ? 'com' : 'sem' }} café da manhã pode estar disponível por dia no mesmo quarto.</template>
                        <template v-else>Selecione pelo menos um dia da semana</template>
                    </span>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>
import FareExpirationMixin from "../../../mixins/Fares/FareExpirationMixin";

export default {
    name: "Fare",
    mixins: [FareExpirationMixin],
    props: {
        fareIndex: {
            type: Number
        },
        roomFare: {
            type: Object,
            default: null
        },
        disabledDays: {
            type: Array,
            default: []
        }
    },
    data: () => ({
        breakfast: false,
        refundable: false,
        daysBefore: null,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2
        },
        value: 'R$ 0,00',
        expirationDate: null,
        expirationDateMenu: false,
        active: '',
        weekDays: [],
        daysOfWeek: [
            { label: 'Segunda', value: 'monday' },
            { label: 'Terça', value: 'tuesday' },
            { label: 'Quarta', value: 'wednesday' },
            { label: 'Quinta', value: 'thursday' },
            { label: 'Sexta', value: 'friday' },
            { label: 'Sábado', value: 'saturday' },
            { label: 'Domingo', value: 'sunday' }
        ],
        visibleExpirationDateRules: [
            v => !!v || 'Campo obrigatório',
        ],
        valueRules: [
            v => !!v || 'Campo obrigatório',
            v => v.length > 0 || 'Campo obrigatório',
            v => parseInt(v.replace(/[^\d-]/g, '')) >= 100 || 'O valor deve ser maior ou igual a R$ 1,00'
        ],
        daysBeforeRules: [
            v => !!v || 'Campo obrigatório.'
        ],
    }),
    created () {
        if (this.roomFare !== null) {
            this.setData();
        }
        const self = this;
        this.$nextTick(function () {
            self.emitFareState();
        });
    },
    methods: {
        getData() {
            return {
                "breakfast": this.breakfast,
                "refundable": this.refundable,
                "value": this.value,
                "daysBefore": this.daysBefore,
                "id": this.roomFare !== null ? this.roomFare.id : null,
                "active": true,
                "expirationDate": this.expirationDate,
                "rules": this.getFormattedFareRules()
            }
        },
        setData() {
            this.breakfast = this.roomFare.breakfast;
            this.refundable = this.roomFare.refundable;
            this.daysBefore = this.roomFare.days_before_checkin;
            var reais = (this.roomFare.amount / 100).toFixed(2).replace('.', ',');
            this.value = 'R$ ' + reais;
            this.active = this.roomFare.active;
            this.weekDays = this.getWeekDaysRuleFromRoomFare();
        },
        isDayDisabled(dayValue) {
            return this.disabledDays.indexOf(dayValue) !== -1;
        },
        toggleDay(dayValue) {
            var index = this.weekDays.indexOf(dayValue);
            if (index === -1) {
                if (this.isDayDisabled(dayValue)) {
                    return;
                }
                this.weekDays.push(dayValue);
            } else {
                this.weekDays.splice(index, 1);
            }
        },
        emitFareState () {
            this.$emit('fare-state-changed', {
                fareKey: this.fareIndex,
                weekDays: this.weekDays.slice(),
                breakfast: this.breakfast
            });
        },
        removeFare () {
            this.$emit('removeFare', this.fareIndex);
        },
        getAllWeekDaysValues () {
            return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
        },
        getWeekDaysRuleFromRoomFare () {
            const allDays = this.getAllWeekDaysValues();
            const rules = this.roomFare.rules;
            if (!rules || !rules.applicability) { return allDays; }
            const applicability = rules.applicability;
            if (!applicability.week_days_rule) { return allDays; }
            return allDays.filter(function (day) { return applicability.week_days_rule[day] === true; });
        },
        getWeekDaysChipColor (day) {
            if (this.isDayDisabled(day.value)) {
                return 'grey lighten-2';
            }

            return this.weekDays.indexOf(day.value) !== -1 ? 'primary' : '';
        },
        getFormattedFareRules () {
            return {
                applicability: [
                    {
                        week_days_rule: {
                            sunday: this.hasSelectedWeekDay('sunday'),
                            monday: this.hasSelectedWeekDay('monday'),
                            tuesday: this.hasSelectedWeekDay('tuesday'),
                            wednesday: this.hasSelectedWeekDay('wednesday'),
                            thursday: this.hasSelectedWeekDay('thursday'),
                            friday: this.hasSelectedWeekDay('friday'),
                            saturday: this.hasSelectedWeekDay('saturday')
                        }
                    }
                ]
            }
        },
        hasSelectedWeekDay (weekDay) {
            return this.weekDays.includes(weekDay);
        }
    },
    computed: {
        today () {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        visibleExpirationDate () {
            if (this.expirationDate === null) { return null; }
            return this.formatDateTimeIntoDate(this.expirationDate);
        },
        hasSelectedAtLeastOneWeekDay () {
            return this.weekDays.length > 0;
        },
        hasValidExpirationDate () {
            return !!this.expirationDate;
        },
        hasValidValue () {
            return parseInt(this.value.replace(/[^\d-]/g, '')) >= 100;
        },
        allDaysBlocked () {
            return this.daysOfWeek.every(day => this.isDayDisabled(day.value));
        },
    },
    watch: {
        disabledDays: function (newDisabledDays) {
            const self = this;
            newDisabledDays.forEach(function (day) {
                const index = self.weekDays.indexOf(day);
                if (index !== -1) {
                    self.weekDays.splice(index, 1);
                }
            });
        },
        weekDays: {
            handler: function () {
                this.emitFareState();
            },
            deep: true
        },
        breakfast: function () {
            this.emitFareState();
        }
    },
}
</script>

<style lang="scss" scoped>
.fare {
    border: 1px solid #E6E6E7;
    border-radius: 1rem;
    margin: 0.5rem 0;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 100%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.fare-card-subtitle {
    font-size: 18px;
    font-weight: 500;
}

.fare .v-input--checkbox .v-label {
    margin-bottom: 0;
}

.v-alert__icon {
    margin: 0;
}

.remove-fare-button {
    height: 1.5rem;
    width: 1.5rem;
}

.fare-title-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 0.5rem;
}

.fare-title {
    font-weight: 600;
    color: #00538D;
}

.justify-center {
    text-align: center !important;
}

.fare-row {
    td {
        border: 0.5px solid #F5F5F6;
        padding: 0.5rem 0;
        text-align: center;

        .content-center {
            display: flex;
            justify-content: center;
            align-items: center;

            :deep(.v-input__slot::before) {
                border: none !important;
            }

            .v-text-field__slot input {
                text-align: center;
            }
        }

        .daily-value {
            max-width: 120px !important;
            margin: 0 auto;
        }

        .expiration-date {
            max-width: 146px !important;
            margin: 0 auto;
        }

        .refund-advance {
            max-width: 50px;
            margin: 0 auto;
        }

    }
}

.fare-week-days-row {
    td {
        border: 0.5px solid #F5F5F6;
        padding: 0.25rem 0.5rem;
        background-color: #FAFAFA;
    }

    .week-days-label {
        font-size: 0.875rem;
        font-weight: 600;
        color: #696A71;
        white-space: nowrap;
    }
}

.fare-section-label {
    font-weight: 600;
    font-size: 0.85rem;
    color: #666;
    margin-bottom: 0.5rem;
}

.week-days-selector {
    display: flex;
    flex-wrap: wrap;
}

.week-days-error-message {
    font-size: 0.75rem;
}

.disabled-day-chip {
    opacity: 0.6;
    cursor: not-allowed !important;
}
</style>
